import 'twin.macro';
import React, { useState } from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { ArrowRightIcon as ArrowRight } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { ClassroomsOrgSettings } from 'containers/MesAnneesScolaires/School/Classrooms/ClassroomsOrgSettings';
import { ClassroomsOrg } from 'types/school';

interface Props {
  onSubmit: (classroomsOrg: ClassroomsOrg) => void;
  onCancel: () => void;
  value: ClassroomsOrg;
  nextStepLabel: string;
}

export function Step3bis(props: Props) {
  const { onSubmit, onCancel, nextStepLabel } = props;
  const { t } = useTranslation(['common']);
  const [classroomsOrg, setClassroomsOrg] = useState<ClassroomsOrg>(
    props.value,
  );

  return (
    <div>
      <div tw="mb-10">
        <ClassroomsOrgSettings
          value={classroomsOrg}
          onChange={setClassroomsOrg}
        />
      </div>
      <div tw="flex justify-center space-x-4 items-center">
        <Button large minimal onClick={onCancel}>
          {t('common:buttons.previous')}
        </Button>
        <Button
          intent="primary"
          onClick={() => onSubmit(classroomsOrg)}
          large
          rightIcon={ArrowRight}
        >
          {nextStepLabel}
        </Button>
      </div>
    </div>
  );
}
